import React from 'react'
import { useLocation } from 'react-router-dom'
import FooterItem from './item'
import AddFundSpeedDial from './addFundSpeedDial'
interface IFooterProps {
    menus: Array<IMenu>
}
interface IMenu {
    title: string
    icon: string
    activeIcon: string
    route: string
    isMain?: boolean
    main: boolean
    role: string
}

const Footer = ({ menus }: IFooterProps) => {
    const { pathname } = useLocation()
    const isFund: boolean = pathname.includes('funds')
    return (
        <>
            {isFund && <AddFundSpeedDial />}
            {/* From md up the bar floats as a dock under the page instead of
                stretching across the frame: four tabs spread over 720px sit
                too far apart to read as one control. The outer box ignores
                pointer events there so the page stays clickable beside it. */}
            <div className="fixed bottom-0 left-0 w-full z-20 md:pointer-events-none md:px-4 md:pb-3">
                <div className="bg-white shadow-nav border-t border-black/5 rounded-t-2xl pb-[var(--safe-bottom)] md:pointer-events-auto md:mx-auto md:max-w-[480px] md:rounded-2xl md:border">
                    <div className="flex justify-around items-stretch relative">
                        {React.Children.toArray(
                            menus.map((item) => (
                                <FooterItem
                                    role={item.role}
                                    isMain={item?.isMain}
                                    title={item?.title}
                                    icon={item?.icon}
                                    router={item?.route}
                                    isActive={pathname.includes(item.route)}
                                    main={item.main}
                                    activeIcon={item.activeIcon}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
